var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",attrs:{"href":_vm.url.replace('internal:', '')},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onLinkClick(_vm.url)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }